import type { ApolloError } from "@apollo/client";
import { To } from "react-router";

import { GaiaExpandableMapMarker } from "~/modules/plannerV2/components/GaiaExpandableMapMarker";

import { GaiaExpandableMapMarkerAreaBodyFragment, GaiaExpandableMapMarkerAreaPlannerAreaFragment } from "./fragments.generated";
import { GaiaExpandableMapMarkerAreaBody } from "./GaiaExpandableMapMarkerAreaBody";
import { GaiaExpandableMapMarkerAreaHeader } from "./GaiaExpandableMapMarkerAreaHeader";

export type GaiaExpandableMapMarkerAreaProps = {
    area: GaiaExpandableMapMarkerAreaPlannerAreaFragment;
    possibleAdjacentVisits: GaiaExpandableMapMarkerAreaBodyFragment["combinable"];
    areaNameHref: (areaId: string) => To;
    onVisitAdd: (timeslotId: string, visitId: string) => void;
    disabled: boolean;
    error?: ApolloError;
};

export function GaiaExpandableMapMarkerArea({
    area,
    possibleAdjacentVisits,
    areaNameHref,
    onVisitAdd,
    disabled,
    error,
}: GaiaExpandableMapMarkerAreaProps) {
    return (
        <GaiaExpandableMapMarker headerHeight={64}>
            <GaiaExpandableMapMarkerAreaHeader area={area} areaNameHref={areaNameHref} />
            <GaiaExpandableMapMarkerAreaBody
                possibleAdjacentVisits={possibleAdjacentVisits}
                onVisitAdd={onVisitAdd}
                disabled={disabled}
                error={error}
            />
        </GaiaExpandableMapMarker>
    );
}
